<template>
    <div class="guest-details" id="party">
<!-- <pre>openMainBookerState: {{openMainBookerState}}</pre>
<pre>openCompanionState: {{openCompanionState}}</pre>
<pre>isInsert: {{isInsert}}</pre>
<pre>companionIndex: {{companionIndex}}        </pre> -->
        <div id="mainBookerInfo" v-if="getMainBooker&&!openMainBookerState&&!openCompanionState">  
            <h2>{{ $t("Your party") }}</h2>                     
            <p><strong>{{ $t("To continue with your booking we need to know some details about all members of your party. Please add them by clicking “add new companion” if they are not already listed here.") }}</strong></p>
            <h3 class="customer-title"> {{getMainBooker.Name}} {{getMainBooker.LastName}} <a href="#"
                @click.prevent="editMainBooker"
                style="float:right"
                class="button blue btn-xs">{{ $t("Amend these details") }}</a>         </h3>
            {{ $t("DOB") }}: <span>{{getMainBooker.DOB}}</span> <br>
            {{ $t("Email") }}: <span>{{getMainBooker.EMail}}</span> <br>
            {{ $t("Phone") }}: <span>{{getMainBooker.Phone}}</span> <br>
            {{ $t("Address") }}: <span>
                {{getMainBooker.House}}
                {{getMainBooker.Street}}
                {{getMainBooker.Locality}}
                {{getMainBooker.Town}}
                {{getMainBooker.County}}
                {{getMainBooker.Country}}
                {{getMainBooker.Postcode}}
            </span>
        </div>
        <SearchCustomer 
            v-if="!getMainBooker||this.openMainBookerState"
            @saved="mainBookerSaved"
            :customer="getMainBooker"  
            :isInsert="isInsert"    
            >
                <h3> 
                    <span v-if="isInsert">{{ $t("Add") }}</span>
                    <span v-else>{{ $t("Edit") }}</span>
                    {{ $t("primary booker") }}</h3>
                <p>{{ $t("Please enter details of the primary booker, ie the person we'll write to with confirmation.") }}</p>
            </SearchCustomer>


        <div class="getcompanions" v-if="!openMainBookerState">

            <div v-if="!openCompanionState">
                <div v-for="(companion,index) in getCompanions" :key="index">
                    <h3 class="customer-title"> {{companion.Name}} {{companion.LastName}} 
                     <a href="#" 
                        @click.prevent="deleteCompanion(index)"
                        class="button btn-xs" 
                        style="background:#f33;color:white;float:right;margin-left:10px">X</a>         
                     <a href="#" 
                        @click.prevent="editCompanion(index)"
                        class="button blue btn-xs" 
                        style="float:right">{{ $t("Amend these details") }}</a>         
                     </h3>
                    {{ $t("DOB") }}: <span>{{companion.DOB}}</span> <br>
                    {{ $t("Email") }}: <span>{{companion.EMail}}</span> <br>
                    {{ $t("Phone") }}: <span>{{companion.Phone}}</span> <br>
                    {{ $t("Address") }}: <span>
                        {{companion.House}}
                        {{companion.Street}}
                        {{companion.Locality}}
                        {{companion.Town}}
                        {{companion.County}}
                        {{companion.Country}}
                        {{companion.Postcode}}
                    </span>

                </div>
                
            </div>

            <SearchCustomer 
                v-if="getMainBooker&&this.openCompanionState"
                @saved="companionSaved"  
                :customer="getCompanions[companionIndex]"  
                :isMainBooker="false"  
                :isInsert="isInsert"    
                >
                    <h3>
                        <span v-if="isInsert">{{ $t("Add") }}</span>
                        <span v-else>{{ $t("Edit") }}</span>
                        {{ $t("companion") }}</h3>
                    <p>{{ $t("Please enter details for the companion.") }}</p>
                </SearchCustomer>  
<h3 class="add">
            <a href="#"
                class="button blue btn-sm"
                v-if="getMainBooker&&!openCompanionState"
                @click.prevent="addCompanion"
                >{{ $t("Add new companion") }}</a>
</h3>

        </div>
        <div v-if="getMainBooker&&!openMainBookerState&&!openCompanionState" class="continue_button">  
            <p>{{ $t("When you have added all members of your party, please click “Continue”") }}</p>
            <h3 class="add">
                <a href="#" class="button blue" v-if="false">Phone me</a> &nbsp; 
                <a href="#" class="button blue" @click.prevent="continueToVehicles">{{ $t("Continue") }} &gt;&gt;</a> 
            </h3>
        </div>
    </div>
</template>
<script>
// @ is an alias to /src
import SearchCustomer from "@/components/SearchCustomer.vue";
import { mapGetters } from 'vuex';

export default {
    name: "GuestDetails",
    components: {
        SearchCustomer
    },
    data() {
        return {
            openMainBookerState:false,
            openCompanionState:false,
            isInsert:true,
            companionIndex:null,
        }
    },
    methods: {
        editMainBooker() {
            this.isInsert=false;
            this.openMainBookerState=true;
        },
        scrollToTop() {
            var elmnt = document.getElementById("party");
            setTimeout(function() {
                elmnt.scrollIntoView();
                // console.log('elmnt',elmnt);
            },10);
            // console.log('elmnt2',elmnt);
        },
        
        mainBookerSaved(value) {
            this.$store.commit('UPDATE_MAIN_BOOKER', value );
            this.openMainBookerState=false;
            this.isInsert=true;
            // console.log('mainBookerSaved');
            this.scrollToTop();
        },
        addCompanion(){
            this.openCompanionState=true;
            this.isInsert=true;
        },
        editCompanion(index) {
            this.companionIndex=index;
            this.openCompanionState=true;
            this.isInsert=false;
        },
        companionSaved(value){
            if (this.isInsert) {
                this.$store.commit('INSERT_COMPANION', value );
            }
            this.openCompanionState=false;
            // console.log('companionSaved');
            this.scrollToTop();
        },
        deleteCompanion(index) {
            this.$store.commit('DELETE_COMPANION', index );
        },
        continueToVehicles() {
            this.$router.push({name: "Vehicles",hash:'#appTop'});
        }
    },
    computed: {
        ...mapGetters([
            'getMainBooker',
            'getCompanions',
        ]), 
    }
};
</script>

<style scoped>
</style>